import { HTMLProps, ReactNode } from 'react';

import Link, { LinkProps } from 'next/link';

export interface SidebarLinkProps {
  className?: string;
  href: string;
  children?: ReactNode;
}

type DropdownLinkProps = SidebarLinkProps &
  (
    | ({
        as?: 'Link';
      } & Omit<LinkProps, 'href' | 'ref'>)
    | ({
        as?: 'a';
      } & Omit<HTMLProps<HTMLAnchorElement>, 'href' | 'ref'>)
  );

export type DropdownLinks = Array<DropdownLinkProps>;

export default function SidebarLink(props: DropdownLinkProps) {
  const { className, as, onClick, children, href, ...restProps } = props;

  if (as === 'a' || href.startsWith('http') || href.startsWith('mailto:')) {
    return (
      <li className="v2-whitespace-nowrap v2-font-sweet-sans-pro v2-font-normal">
        <a
          href={href}
          className={className}
          onClick={event => {
            localStorage.setItem('sidebar-nav-clicked', 'true');
            onClick && onClick(event);
          }}
          {...restProps}
        >
          {children}
        </a>
      </li>
    );
  }

  return (
    <li className="v2-whitespace-nowrap v2-font-sweet-sans-pro v2-font-normal">
      <Link
        href={href}
        className={className}
        onClick={event => {
          localStorage.setItem('sidebar-nav-clicked', 'true');
          onClick && onClick(event);
        }}
        {...restProps}
      >
        {children}
      </Link>
    </li>
  );
}
